import * as actions from './actions';
import * as getters from './getters';
import { SET_CURRENT_BOOKING_EVENT, SET_CURRENT_BOOKING_EVENT_ID } from '../../mutation-types';


const mutations = {
  [SET_CURRENT_BOOKING_EVENT](state, payload) {
    state.currentEvent = payload
  },
  [SET_CURRENT_BOOKING_EVENT_ID](state, payload) {
    state.currentEventId = payload
  },
};

const state = {
  currentEventId: null,
  currentEvent: null,
  url: 'v1/reservation'
};

export default {
  namespaced: true,
  mutations,
  actions,
  getters,
  state,
};
